const dev = process.env.NODE_ENV !== 'production'
// this should be the domain
// noinspection JSUnresolvedReference
export const server = dev ? 'https://localhost:3000' : process.env.PROD_DOMAIN_URL
